export const SHOW_REFRESH_MODAL = 'SHOW_REFRESH_MODAL'
export const SET_LOAN_ID_FOR_ENCOMPASS = 'SET_LOAN_ID_FOR_ENCOMPASS'

export function showRefreshModal() {
  return {
    type: SHOW_REFRESH_MODAL,
    showRefreshModal: true,
  }
}

export function setLoanIdForEncompass(loanIdForEncompass) {
  return {
    type: SET_LOAN_ID_FOR_ENCOMPASS,
    loanIdForEncompass,
  }
}
